import RecentCustomers from './recent_customers';

export default RecentCustomers;
